import{jsx as r}from"react/jsx-runtime";import{Sticky as t,StickyPositionType as i}from"@fluentui/react";const o=(o,e)=>r(t,{stickyPosition:i.Header,stickyBackgroundColor:"transparent",children:r("div",{children:e(o)})});export{o as handleRenderDetailsStickyHeader};
//# sourceMappingURL=utils.js.map
